import React, { Component } from 'react';
import { apiURL } from '../utils';  
import Footer from '../include/Footer';
import Header from '../include/Header';
import { makeStyles, withStyles } from '@material-ui/core/styles'; 
import { CssBaseline, Grid, Container,Table, TableBody, TableCell, TableHead, TableRow, Snackbar, Switch, Dialog, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert'; 
import axios from 'axios';
import Helmet from 'react-helmet';
import Delete from "../delete/Delete";

import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';   
import Box from '@material-ui/core/Box';
import "../style/Style.css";  
import PageviewIcon from '@material-ui/icons/Pageview';
import XLSX from 'xlsx';
import ExportExcelButton from '../utils/ExportExcelButton';

const drawerWidth = 280;
// const useStyles = makeStyles((theme) => ({

// }))

const useStyles = theme => ({
    buttonEdit: {
      textTransform:'capitalize',
      border:'1px solid #035eab',
      borderRadius:'0px',
      marginRight:'10px',
      padding:'2px 5px',
    },
    buttonAdd:{
      textTransform:'capitalize',
    },
    table:{
        minWidth: 650,
    },
   
   
  });


 class Help_us_to_improve extends Component {
    _isMounted = false;
    constructor(props){
        super(props);
        this.state = {
           // drawerOpen: false,
            drawerOpen: true,
            hutiData: [],
            page: 1,
            per:20,
            total_pages: null,
            loading: false, 
            showSnackbar: false,
            snackBarMessage: '',
            severityColor: '',
            noData: "",
            viewDiallogData: false,
            subject: '',
            message: '',
        }
        this.handleDrawerOpen    = this.handleDrawerOpen.bind(this);
        this.changeStatus        = this.changeStatus.bind(this);
        this.ViewData            = this.ViewData.bind(this);
    }

    handleDrawerOpen(drawerState){
        this.setState({
          drawerOpen: drawerState,
        })
    }

    componentDidMount() { 
        this._isMounted = true; 
        this.getInTouchListData(); 
        this.scrollListener = window.addEventListener("scroll", e => {
            this.handleScroll(e);
        });
    }

    componentWillUnmount() {
        this._isMounted = false; 
    }
  
    getInTouchListData = () => {
        this.setState({ loading: true });
        const { per, page, contactData } = this.state; 
        const headers = { 
            'Content-type': 'application/json'
        }
        axios.post(apiURL('help_us_to_improve?per_page='+per+'&page='+page), {headers: headers})
        .then(response => {
            
        if(this._isMounted){
            const resultData = response.data; 
            if(resultData.status === true || resultData.status === 1)
            { 
                this.setState({  
                    hutiData: (resultData.total < 20)?resultData.result:[...this.state.hutiData, ...resultData.result],
                    scrolling: false,
                    total_pages: resultData.total_pages,
                });
                this.setState({ loading: false });
            }
            else{
                this.setState({ loading: false, noData: "no Data Found" }); 
            }
        }
        })
        .catch(error => {
            console.log(error)
        })
    }

    loadMore = () => { 
        if(this._isMounted){
            this.setState(
            prevState => ({
                page: prevState.page + 1,
                scrolling: true
            }),
            this.articleListData
            ); 
        }
      };

      handleScroll = () => {   
        if(this._isMounted){ 
            var lastLi = document.querySelector("Table"); 
            if(lastLi !== null){
                var lastLiOffset = lastLi.offsetTop + lastLi.clientHeight;
                var pageOffset = window.pageYOffset + window.innerHeight;
                if (pageOffset > lastLiOffset) {
                    this.loadMore();
                } 
            }
        }
      };


    changeStatus = (id, status) => { 
        const headers = { 
            'Content-type': 'application/json'
        }
        axios.get(apiURL('help_us_to_improve/change_status/'+id+'/'+status), {headers: headers})
        .then(response => {
            const resultData = response.data; 
            if(resultData.status === true || resultData.status === 1)
            { 
                const updatedHUTIData = this.state.hutiData.map(huti=>{
                    if(huti.fldi_id === id){
                        const _huti = {...huti};
                        _huti.flg_status = status==="0"?"1":"0";
                        return _huti;
                    }
                    return  huti;
                });
                this.setState({ hutiData: updatedHUTIData });
            }
        })
        .catch(error => {
            console.log(error)
        })
      }

    snackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
          }
          this.setState({ showSnackbar: false }); 
    }

    ViewData = (e) => {
            this.setState({ 
                viewDiallogData: true,
                name: e.fldv_name,
                email: e.fldv_email,
                contact: e.fldv_contact,
                subject: e.fldv_subject,
                message: e.fldt_message,
            });
    }

    handleClose = () => {
        this.setState({ 
            viewDiallogData: false,
            name: '',
            email: '',
            contact: '',
            subject: '',
            message: '',
        });
    }

    successDelete = (e, id, index) => {  
        if(e === true){
            const deleteData = this.state.hutiData;
            deleteData.splice(index, 1);
            this.setState({
                hutiData: deleteData, 
                showSnackbar: true, 
                snackBarMessage: "data deleted suceesfully", 
                severityColor: 'success',
                snackBarTimer: 3000
            }); 
        } 
    }

    
    exportFile(e) {
        let teams = [["Name", "Email", "Contact", "Status", "Delete"]]
        this.state.hutiData.forEach((team) => {
          let teamArray = [team.fldv_name, team.fldv_email, team.fldv_contact, (team.flg_status === '1')?"Active":"Deactive", (team.flg_is_deleted === '1')?"Not Delete":"Deleted"]
          teams.push(teamArray)
        })
    
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(teams)
        
        XLSX.utils.book_append_sheet(wb, wsAll, "Help us to Improve")
            XLSX.writeFile(wb, "export-help-us-to-improve.xlsx")
    }

    render(){
        const { classes } = this.props; 
        const loadingCSS = {
            height: "30px",
            margin: "10px"
          };
        const loadingTextCSS = { display: this.state.loading ? "block" : "none" };
        return(
            <React.Fragment>
            <Helmet>
                <title>Contact Us Enquiry</title>
            </Helmet>
                <Header forwardDrawerOpen={this.handleDrawerOpen.bind(this)}  />
                <CssBaseline /> 
                <div style={{ paddingTop: '5rem', paddingLeft: (this.state.drawerOpen?drawerWidth+15:72+15), transition: 'padding 0.5s ease'   }}>
                    <main>    
                        <Container maxWidth="lg" > 
                        <Box  bgcolor="background.paper" mt={2} boxShadow={3}>
                        <Alert 
                             action={
                                <div> 
                                   {/*} <TextField className="textField"  type="text" placeholder="...Search"  
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            style: {color: '#414141',backgroundColor:'rgba(255, 255, 255, 0.29)'}
                                        }} 
                                        size="small"
                                        id="search"
                                        variant="outlined"
                                        style={{fontColor:"#fff"}} 
                                        name="search"
                                        onChange={e => this.searchHandler(e)} 
                                    /> */}
                                    <ExportExcelButton clickProp={(e) => this.exportFile(e)}/>
                                </div>
                            } 
                            variant="outlined" severity="default" boxShadow={3}><h2>Help us to Improve</h2>
                        </Alert>
                        </Box>
                            <Grid container spacing={3}  align="center" > 
                                <Grid item xs={12}>  
                                <Box  bgcolor="background.paper" boxShadow={3} px={2} py={2} mt={1}>
                                <TableContainer  mt={1} component={Paper} className="customTable">
                                    <Table size="small" stickyHeader aria-label="sticky table">
                                        <TableHead> 
                                            <TableCell  style={{width:'2rem'}}>Id</TableCell> 
                                            <TableCell> Name</TableCell> 
                                            <TableCell> Email</TableCell> 
                                            <TableCell> Contact</TableCell> 
                                            <TableCell  style={{width:'3rem'}}>Status</TableCell>  
                                            <TableCell style={{width:'3rem'}}>Action</TableCell> 
                                        </TableHead>
                                        <TableBody> 
                                            {this.state.hutiData.map((arrList, index) => {    
                                             return <TableRow key={arrList.fldi_id}>  
                                                    <TableCell>{index+1}</TableCell> 
                                                    <TableCell>{arrList.fldv_name}</TableCell>
                                                    <TableCell>{arrList.fldv_email}</TableCell>
                                                    <TableCell>{arrList.fldv_contact}</TableCell>
                                                    <TableCell> <Switch size="small" checked={arrList.flg_status==="1"} color="primary" onChange={() => this.changeStatus(arrList.fldi_id, arrList.flg_status)}/></TableCell>
                                                    <TableCell>
                                                        <Button className={classes.buttonEdit} variant="outlined" color="default" startIcon={<PageviewIcon style={{color:'#035eab', marginLeft:'5px',}} />} onClick={() => this.ViewData(arrList)}>View</Button>
                                                        <Delete deleteID={arrList.fldi_id} table={'help_us_to_improve'} onSuccessDelete={(e) => this.successDelete(e, arrList.fldi_id, index)}/>
                                                    </TableCell>
                                                </TableRow>
                                            })} 
                                        </TableBody>
                                    </Table> 
                                    </TableContainer>
                                    </Box>
                              
                                    <div ref={loadingRef => (this.loadingRef = loadingRef)} style={loadingCSS} >
                                        <span style={loadingTextCSS}>Loading...</span>
                                        <span>{(this.state.scrolling)?this.state.noData:""}</span>
                                    </div>
                                    
                                </Grid>
                           </Grid> 
                           <Footer />
                        </Container>
                    </main>
                </div> 

                <Snackbar open={this.state.showSnackbar === true} autoHideDuration={6000} onClose={this.snackBarClose}>
                    <Alert onClose={this.snackBarClose} severity={this.state.severityColor} elevation={6} variant="filled">
                    { this.state.snackBarMessage }
                    </Alert>
                </Snackbar>

                {/* Dialog Data start here */}          
                <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" fullWidth={true} maxWidth={'md'} open={this.state.viewDiallogData}>
                <Box  bgcolor="background.paper" boxShadow={3} px={4} py={4} >
                 <TableContainer  mt={1} component={Paper} className="customTable">
                    <Table size="small" stickyHeader aria-label="sticky table" style={{padding:"1rem"}}>
                        <TableHead> 
                            <TableCell style={{width:"10%"}}>Name</TableCell> 
                            <TableCell style={{width:"10%"}}>Email</TableCell> 
                            <TableCell style={{width:"10%"}}>Contact</TableCell> 
                            <TableCell style={{width:"20%"}}>Subject</TableCell> 
                            <TableCell style={{width:"50%"}}> Message</TableCell> 
                        </TableHead>
                        <TableBody>
                                <TableRow>  
                                    <TableCell>{this.state.name}</TableCell> 
                                    <TableCell>{this.state.email}</TableCell> 
                                    <TableCell>{this.state.contact}</TableCell> 
                                    <TableCell>{this.state.subject}</TableCell> 
                                    <TableCell>{this.state.message}</TableCell>
                                </TableRow>
                        </TableBody>
                    </Table> 

                    </TableContainer>
                    </Box>             
                </Dialog>
                {/* Dialog Data end here */}
            </React.Fragment>
        );
    }
 }
  
 export default (withStyles)(useStyles)(Help_us_to_improve);